import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationService } from '@app/_services';
import { first } from 'rxjs/operators';

@Component({
  selector: 'zipcode-selector',
  templateUrl: './zipcode-selector.component.html',
  styleUrls: ['./zipcode-selector.component.less']
})

export class ZipCodeSelectorComponent implements OnInit {

  zipcodeAddForm: FormGroup;
  eventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private locationService: LocationService,
    private formBuilder: FormBuilder,
  ) {
    this.zipcodeAddForm = this.formBuilder.group({
      zipcode: ['', Validators.required],
    });
   }

  ngOnInit(): void {
  }

  async addLocation() {
    let zipcode = this.zipcodeAddForm.controls['zipcode'].value;
    await this.locationService.getLocationByZipcode(zipcode).pipe(first()).subscribe(data => {
      this.zipcodeAddForm.controls['zipcode'].setValue('');
      this.eventEmitter.emit(data);
    });
  }
}
